import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class ClientModel {
    clientId() {
        return this.dto.clientId;
    }
    name() {
        return this.dto.name;
    }
    clientType() {
        return this.dto.clientType;
    }
    isSample() {
        return this.dto.isSample;
    }
    owner() {
        return this.dto.owner;
    }
    contactsCount() {
        return this.dto.contactsCount;
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
